import { graphql } from '@graphql/__generated'

export const GET_ORDERS_BY_EVENT_ID = graphql(`
  query getOrdersByEventId($eventId: String!, $userIds: [String!]!) {
    getOrdersByEventId(eventId: $eventId, userIds: $userIds) {
      userId
      paid
      eventId
      quantity
      tickets {
        title
        email
        fullName
        discountCode
      }
    }
  }
`)
